<template>
  <v-card class="px-6 pt-6 pb-4">
    <p class="font-bold font-size-20">
      {{ $t('rev.create.create_card_title') }}
    </p>

    <v-row class="d-flex justify-end">
      <v-btn
        color="primary"
        plain
        min-width="145"
        :loading="isDownloadingQR"
        @click="downloadQRCode"
      >
        <template v-if="!isDownloadingQR">
          <v-icon class="me-2" size="16">
            mdi-qrcode
          </v-icon>

          {{ $t('rev.create.qr_code_button') }}
        </template>
      </v-btn>
    </v-row>

    <v-card-text class="pa-0">
      <v-row no-gutters class="justify-center">
        <v-col
          v-for="type in typeCards"
          :key="type.type"
          :md="hasLimitedCards ? 3 : 4"
          cols="12"
          sm="12"
          class="justify-center d-flex mt-6"
        >
          <TypeCard
            data-testid="create_rev_type_card"
            data-tourid="create_rev_type_card"
            :description="type.description"
            :icon="type.icon"
            :type="type.type"
            :title="type.title"
            @click="$emit('selected', type.type)"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <QRCode ref="qrCode" />

    <v-card-actions class="justify-end pa-0 mt-6 mb-0">
      <Button
        plain
        color="grey"
        :text="$t('common.button.cancel')"
        @click="$emit('close')"
        data-testid="revs_modal_create_cancel"
        data-tourid="crevs_modal_create_cancel"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

import { createLetterPdf } from '@/lib/pdf'
import Button from '@/components/UI/Button.vue'

import TypeCard from './TypeCard.vue'
import QRCode from './QRCode.vue'

export default {
  name: 'TypeSelectionStep',

  components: {
    Button,
    TypeCard,
    QRCode,
  },

  props: {
    typeCards: {
      type: Array,
      default() {
        return []
      },
    },

    hasLimitedCards: Boolean,
  },

  data() {
    return {
      isDownloadingQR: false,
    }
  },

  methods: {
    async downloadQRCode() {
      try {
        this.shouldMountQr = true
        this.isDownloadingQR = true

        await this.$nextTick()

        const canvas = await html2canvas(this.$refs.qrCode.$el, {
          type: 'dataURL',
        })
        const doc = createLetterPdf('p', jsPDF)
        const imgData = canvas.toDataURL('image/png')

        doc.addImage(imgData, 'PNG', 55, 50, 100, 140)
        doc.save('Rever_create_content_QR.pdf')
      } catch (err) {
        this.showError(err.message)
      } finally {
        this.shouldMountQr = false
        this.isDownloadingQR = false
      }
    },
  },
}
</script>
